import { flatten } from 'lodash';

/* 
  References: 
    https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types#common_image_file_types
    https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Containers
*/
export const FILE_EXTENSIONS = [
  'apng',
  // 'avif',
  'gif',
  'jpg',
  'jpeg',
  'jfif',
  'pjpeg',
  'pjp',
  'png',
  'webp',

  'mp3',
  'wav',
  '3gp',
  'mpg',
  'mpeg',
  'm4a',
  'oga',
  'ogg',
  'webm',

  'mp4',
  'webm',
  '3gp',
  'mpg',
  'mpeg',
  'm4v',
  'm4p',
  'ogv',
  'ogg',
  'mov',
  'avi',
  'quicktime',

  'csv',
  'pdf',
  'txt',
  'xlsx',
  'docx',
  'pptx',
  'xls',
  'ppt',
  'doc',
] as const;

export const IMAGE_TYPES = [
  'apng',
  // 'avif',
  'gif',
  'jpg',
  'jpeg',
  'jfif',
  'pjpeg',
  'pjp',
  'png',
  'webp',

  'image/apng',
  // 'image/avif',
  'image/gif',
  'image/jpg',
  'image/jpeg',
  'image/jfif',
  'image/pjpeg',
  'image/pjp',
  'image/png',
  'image/webp',
];

export const AUDIO_TYPES = [
  'mp3',
  'wav',
  '3gp',
  'mpg',
  'mpeg',
  'm4a',
  'oga',
  'ogg',
  'webm',

  'audio/mp3',
  'audio/wav',
  'audio/3gp',
  'audio/mpg',
  'audio/mpeg',
  'audio/m4a',
  'audio/oga',
  'audio/ogg',
  'audio/webm',
];

export const VIDEO_TYPES = [
  'mp4',
  'webm',
  '3gp',
  'mpg',
  'mpeg',
  'm4v',
  'm4p',
  'ogv',
  'ogg',
  'mov',
  'avi',
  'quicktime',

  'video/mp4',
  'video/webm',
  'video/3gp',
  'video/mpg',
  'video/mpeg',
  'video/m4v',
  'video/m4p',
  'video/ogv',
  'video/ogg',
  'video/mov',
  'video/avi',
  'video/quicktime',
  'video/x-matroska',
];

export const DOCUMENT_MIME_WITH_EXTENSIONS_TYPES: Record<string, string[]> = {
  'text/csv': ['.csv'],
  'application/pdf': ['.pdf'],
  'text/plain': ['.txt'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/msword': ['.doc'],
};
export const DOCUMENT_EXTENSION_TYPES = flatten(
  Object.keys(DOCUMENT_MIME_WITH_EXTENSIONS_TYPES).map((key) =>
    DOCUMENT_MIME_WITH_EXTENSIONS_TYPES[key].map((extension) =>
      extension.slice(extension.indexOf('.') + 1),
    ),
  ),
);
export const DOCUMENT_MIME_TYPES = Object.keys(DOCUMENT_MIME_WITH_EXTENSIONS_TYPES);
export const DOCUMENT_TYPES = [...DOCUMENT_EXTENSION_TYPES, ...DOCUMENT_MIME_TYPES];

export const ATTACHMENT_TYPES = [...IMAGE_TYPES, ...AUDIO_TYPES, ...VIDEO_TYPES, ...DOCUMENT_TYPES];

export const MEDIA_ATTACHMENT_TYPES = [...IMAGE_TYPES, ...AUDIO_TYPES, ...VIDEO_TYPES];
